import { Organization } from 'src/app/core/model/organization';

export interface Chatbot
{
  baseUrl: string;
  appId: string;
  hash: string;
  organization: string;
}

export class User
{
  public id: any;
  public userName: string;
  public username: string;
  public firstName: string;
  public lastName: string;
  public name: string;
  public department: string;
  public departmentName: string;
  public organization: string;
  public organizationName: string;
  public email: string;
  public mobile: string;
  public differentAuthMethodAllowed: boolean;
  public token: string;
  public qrCode: any;
  public password: string;
  public photo: any;
  public enabled = true;
  public preferredLanguage = 'English';
  public role: string;
  public roleName: string;
  public inRegistration = false;
  public servicesAccount = false;
  public linkedFHIRUser = false;
  public isEHROnlyAccess = false;
  public phoneNumber: string;
  public lastLoggedOn: Date;
  public authenticated: boolean;
  public twoFa: boolean;
  public changePassword: boolean;
  public allowedRoles = [];
  public allowedOrganizations = [];
  public chatbot: Chatbot;
  public organizationId: number;
}

export class Group
{
  public id: number;
  public version: number;
  public name: string;
  public active = true;
  public description: string;
  public users: User[] = [];
  public organization: Organization;
}
